export default "__VITE_ASSET__D$Jt8Vlp__"